// @ts-strict-ignore
import type { ReactNode } from "react";

import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { Container } from "@shared/layouts";
import { OAuthOnboardingHeader } from "@unauthenticated/oauth/components/OAuthOnboardingFlow/OAuthOnboardingWrapper/OAuthOnboardingHeader/OAuthOnboardingHeader";
import { SignUpCarouselOrFooter } from "@unauthenticated/shared/components/SignUpCarouselOrFooter/SignUpCarouselOrFooter";

import { OAuthStep } from "../oauthStep";

import * as styles from "./OAuthOnboardingWrapper.styles";

interface Props {
  applicationLogo: string;
  currentStep: OAuthStep;
  onUpdateCurrentStep: (step: OAuthStep) => void;
  children: ReactNode;
  headerRightContent?: ReactNode;
}

const OAuthOnboardingWrapper = ({
  applicationLogo,
  currentStep,
  children,
  onUpdateCurrentStep,
  headerRightContent,
}: Props) => {
  const { desktop } = useBreakpoints();
  const isInSignupStep = currentStep === OAuthStep.SIGN_UP;

  const signInRedirect = () => {
    onUpdateCurrentStep(OAuthStep.SIGN_IN);
  };

  return (
    <Container css={styles.container}>
      <OAuthOnboardingHeader applicationLogo={applicationLogo} rightContent={headerRightContent} />
      <div css={styles.content}>{children}</div>
      <SignUpCarouselOrFooter
        isWithinViewport={!!desktop.lessThan && isInSignupStep}
        hideFooterSignIn={!isInSignupStep}
        onSignInRedirect={!!isInSignupStep && signInRedirect}
      />
    </Container>
  );
};

export { OAuthOnboardingWrapper };
